"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSplittedTextByIndexRanges = void 0;
const getSplittedTextByIndexRanges = (text, indexRanges)=>{
    var _indexRanges_;
    if (indexRanges.length === 0) {
        return [
            {
                substring: text,
                isHighlighted: false
            }
        ];
    }
    const splittedText = [];
    const firstRangeStartIndex = (_indexRanges_ = indexRanges[0]) === null || _indexRanges_ === void 0 ? void 0 : _indexRanges_[0];
    if (firstRangeStartIndex !== undefined && firstRangeStartIndex > 0) {
        splittedText.push({
            substring: text.slice(0, firstRangeStartIndex),
            isHighlighted: false
        });
    }
    for (const [i, currentIndexRange] of indexRanges.entries()){
        var _indexRanges_1;
        const currentRangeEndIndex = currentIndexRange[1];
        let nextRangeStartIndex = (_indexRanges_1 = indexRanges[i + 1]) === null || _indexRanges_1 === void 0 ? void 0 : _indexRanges_1[0];
        if (i === indexRanges.length - 1) {
            nextRangeStartIndex = text.length;
        }
        splittedText.push({
            substring: text.slice(currentIndexRange[0], currentIndexRange[1]),
            isHighlighted: true
        });
        if (currentRangeEndIndex !== undefined && currentRangeEndIndex < text.length) {
            splittedText.push({
                substring: text.slice(currentIndexRange[1], nextRangeStartIndex),
                isHighlighted: false
            });
        }
    }
    return splittedText;
};
exports.getSplittedTextByIndexRanges = getSplittedTextByIndexRanges;
